import React from 'react'

const Context = React.createContext({
    releases: [],    
})

export default Context